<div class="page">
  <app-page-site-switcher *ngIf="false"></app-page-site-switcher>
  <section class="card card--hours">
    <header class="card__header">
      <h2 class="card__title">{{ 'horairesInformations.horaires.title' | translate }}</h2>
      <div class="ora-info">
        <div class="ora-info__icon">
          <img src="assets/IconORA.svg" alt="Ora" />
        </div>
        <p class="ora-info__text">
          {{ 'horairesInformations.horaires.info.line1' | translate }}<br>
          {{ 'horairesInformations.horaires.info.line2' | translate }}
        </p>
      </div>
    </header>

    <div class="hours hours--v2">
      <div
        class="hours3__row"
        *ngFor="let day of ['horairesInformations.horaires.days.monday','horairesInformations.horaires.days.tuesday','horairesInformations.horaires.days.wednesday','horairesInformations.horaires.days.thursday','horairesInformations.horaires.days.friday','horairesInformations.horaires.days.saturday','horairesInformations.horaires.days.sunday']; let i = index"
        [class.is-off]="!daysEnabled[i]">

        <div class="hours3__left">
          <div class="hours3__day">{{ day | translate }}</div>
          <label class="toggle">
            <input
              type="checkbox"
              [checked]="daysEnabled[i]"
              (change)="onToggleDay(i, $any($event.target).checked)" />
            <span class="toggle__track"></span>
          </label>
        </div>

        <div class="hours3__center" *ngIf="daysEnabled[i]; else closedRow">
          <ng-container *ngFor="let s of schedules[i]; let j = index">
            <div class="slot">
              <div class="group">
                <span class="label">{{ 'horairesInformations.horaires.opensAt' | translate }}</span>
                <input class="chip" type="time" [value]="s.open"
                       [class.error]="isSlotInvalid(i, j)"
                       (input)="onTimeChange(i, j, 'open', $any($event.target).value)" />
              </div>
              <div class="group">
                <span class="label">{{ 'horairesInformations.horaires.closesAt' | translate }}</span>
                <input class="chip" type="time" [value]="s.close"
                       [class.error]="isSlotInvalid(i, j)"
                       (input)="onTimeChange(i, j, 'close', $any($event.target).value)" />
              </div>
            </div>
          </ng-container>
        </div>

        <div class="hours3__right" *ngIf="daysEnabled[i]">
          <button type="button" class="sq"
                  *ngIf="(schedules[i] || []).length > 1"
                  (click)="removeLastSlot(i)">−</button>
          <button type="button" class="sq"
                  *ngIf="(schedules[i] || []).length < 4"
                  (click)="addSlot(i)">+</button>
        </div>

        <ng-template #closedRow>
          <div class="closed">{{ 'horairesInformations.horaires.closed' | translate }}</div>
        </ng-template>
      </div>
    </div>

    <div class="form-actions center">
      <button type="button" class="btn-primary-pill" (click)="saveOpeningHours()">{{ 'horairesInformations.horaires.save' | translate }}</button>
    </div>
  </section>

  <!-- Toast succès -->
  <div class="ora-toast" *ngIf="toastVisible" role="status" aria-live="assertive">
    <span class="ora-ico-badge" aria-hidden="true">
      <img class="ora-ico" src="assets/IconORA.svg" alt="">
    </span>
    <span class="ora-txt">
      <span class="ora-title">{{ 'horairesInformations.horaires.toastTitle' | translate }}</span>
      <span class="ora-sub">{{ toastSubtitle }}</span>
    </span>
  </div>
</div>
